import { 
    MessageResponseDto, 
    GetRewardEventDto, 
    CreateRewardEventDto, 
    EditRewardEventDto,
    RewardEventControllerGet200Response,
    RewardEventApiFp,
    DeleteRewardEventDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseRewardEventModel = RewardEventControllerGet200Response;
export type GetRewardEventModel = GetRewardEventDto;
export type MutateResponseRewardEventModel = MessageResponseDto;
export type CreateRewardEventModel = CreateRewardEventDto;
export type UpdateRewardEventModel = EditRewardEventDto;
export type DeleteRewardEventModel = DeleteRewardEventDto;

export const apiRewardEventFp = RewardEventApiFp(apiConfig);
export const getRewardEventController = apiRewardEventFp.rewardEventControllerGet;
export const createRewardEventController = apiRewardEventFp.rewardEventControllerCreate;
export const updateRewardEventController = apiRewardEventFp.rewardEventControllerEdit;
export const deleteRewardEventController = apiRewardEventFp.rewardEventControllerDelete;

export const QueryKeyRewardEvent = QueryKey.RewardEvent;